import View from './MortgageWorkflowView';

export default View;
